// import { i18n } from '@lingui/core';
import { Trans } from '@lingui/macro';
import React from 'react';
import '../common/global.css';
import BackgroundImg from '../img/luat-hn/luathn-bg.jpg';
import logoImg from '../img/luat-hn/luathn_logo.svg';
import { getRedirectUri } from '../util/ChangeLanguage';

const AuthLayout = ({ children }) => {
  return (
    <div
      className={
        'min-h-screen min-w-full bg-no-repeat bg-cover bg-center flex justify-between text-luat_HN_color pl-[80px]'
      }
      style={{ backgroundImage: `url('  ${BackgroundImg}  ')` }}
    >
      <div className="flex flex-col gap-[24px] w-fit mt-[140px]">
        <div className="w-full flex justify-center">
          <a href={getRedirectUri()} className="div-logo text-[25px]">
            <img src={logoImg} />
            <div className="text-white text-[25px] font-bold flex flex-col items-center justify-center ml-[10px]">
              <h2 className="text-luat_HN_text_red">
                ĐOÀN LUẬT SƯ THÀNH PHỐ HÀ NỘI
              </h2>
              <h2 className="text-luat_HN_text_blue_color text-[18px]">
                <span className="mr-[4px]">HANOI</span>{' '}
                <span className="mr-[4px]">BAR</span>{' '}
                <span className="mr-[4px]">ASSOCIATION</span>
              </h2>
            </div>
          </a>
        </div>

        <div className="text-white w-full text-center h-full text-[16px]">
          <h3 className="uppercase text-black mx-auto text-[16px]">
            <Trans>Chào mừng đến với</Trans>
            <span className="text-luat_HN_primary">
              &nbsp;Đoàn Luật sư Thành phố Hà Nội
            </span>
          </h3>
        </div>
      </div>
      <div className="flex justify-center items-center w-1/2 h-full">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
